import { Card, palette, Typography } from "@powerdiary/components-library/lib";
import { Box } from "@mui/material";

import styles from "./PageNotAvailable.module.css";

export default function PageNotAvailable() {
    return (
        <Card
            variant="outlined"
            sx={{ border: `1px solid ${palette.neutral["white"]}` }}
            raised
            data-test-id="section_page_not_available"
        >
            <Box className={styles.content}>
                <img
                    src="/images/out-of-buzz.svg"
                    alt="out of buzz"
                    width="80"
                    height="80"
                    data-test-id="image_out_of_buzz"
                />
                <Typography component="div" variant="heading3" textAlign="center" data-test-id="text_heading">
                    Sorry, it looks like the online portal functionality is not available for this practice.
                </Typography>
                <Typography
                    variant="paragraphMediumRegular"
                    color="text.secondary"
                    textAlign="center"
                    data-test-id="text_content"
                >
                    Please contact them directly to make an appointment.
                </Typography>
            </Box>
        </Card>
    );
}
